import React, { useEffect, useMemo } from 'react';

/* External */
import { withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core';
import moment from 'moment';

import { useTranslation } from 'react-i18next';

/* Project */
import { actionProps, parsedObjects } from 'utils/reduxActions';
import connectSaga from 'utils/saga';
import { dispatchesActions } from 'screens/Dispatches/reducer';
import { appActions } from 'commons/reducer';
import { clone } from 'utils/functions';
import DispatchesComponent from './components';
import saga from './saga';
import styles from './styles';

const useStyles = makeStyles(styles);

const defaultFilters = {
  fromDate: moment().subtract(1, 'month').startOf('month').toISOString(),
  toDate: moment().endOf('month').toISOString(),
  clientId: '',
  supplierId: '',
  productId: '',
  dispatchNumber: '',
  receiptLotNumber: '',
  originProcessNumber: '',
};

const defaultPagination = {
  page: 0,
  rowsPerPage: 10,
  count: 0,
};

function Dispatches(props) {
  const { actions } = props;
  const { t } = useTranslation();

  const headerList = [
    { name: t('Dispatch'), width: '10%', mobileOrder: 1 },
    { name: t('Lot'), width: '10%', mobileOrder: 3 },
    { name: t('Producer'), width: '25%', mobileOrder: 2 },
    { name: t('Client'), width: '25%', mobileOrder: 4 },
    { name: t('Dispatch date'), width: '20%', mobileOrder: 5 },
    { name: '', width: '10%', mobileOrder: 6 },
  ];

  const toDeleteId = useSelector((state) => state.dispatches.toDeleteId);
  const rawObjects = useSelector((state) => state.app.objects);
  const role = useSelector((state) => state.app.role);

  console.log(rawObjects);
  const objects = useMemo(() => parsedObjects(rawObjects), [rawObjects?.dispatches]);

  useEffect(() => {
    actions.changeFilters(defaultFilters);
    actions.getStateFromApi(defaultFilters, defaultPagination);
  }, []);

  const toggleForm = () => {
    actions.toggleForm('formIsOpen');
  };

  const closeForm = () => {
    actions.toggleForm('deleteIsOpen');
  };

  const submitDelete = () => {
    actions.deleteDispatch(toDeleteId);
    toggleForm();
  };

  const classes = useStyles();

  return (
    <DispatchesComponent
      classes={classes}
      toggleForm={toggleForm}
      closeForm={closeForm}
      submitDelete={submitDelete}
      defaultFilters={defaultFilters}
      defaultPagination={defaultPagination}
      headerList={headerList}
      objects={objects}
      role={role}
    />
  );
}

const withSaga = connectSaga({ key: 'sagaDispatches', saga });

const withConnect = connect(
  undefined,
  actionProps(clone(clone.OBJECT, dispatchesActions, appActions)),
  null,
  {},
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Dispatches));
